export default "__VITE_ASSET__Hfchp_A0__"